import PropTypes from 'prop-types';
import React, { Component } from 'react';
import hui from 'hui';
import api from 'axios';
import { memoize } from 'lodash';

const CategoryAutocomplete = hui.CategoryAutocomplete;
const fetchSuggestions = memoize(query => api.get('/api/getquotes/categories', { params: { query } }));

export default class CategorySearch extends Component {
  static propTypes = { // eslint-disable-line
    classPrefix: PropTypes.string,
    placeholder: PropTypes.string,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    onSelect: PropTypes.func
  };

  static defaultProps = { // eslint-disable-line 
    classPrefix: 'hero__gq-category',
    placeholder: 'E.g. Plumber, Electrician, Carpenter'
  };

  state = { // eslint-disable-line
    category: {}
  };

  onSelect = (category) => { // eslint-disable-line 
    if (this.props.onSelect) this.props.onSelect(category);
    this.setState({ category });
  };

  render() {
    const { onFocus, onBlur } = this.props;
    const { category } = this.state;
    return (
      <div>
        <CategoryAutocomplete
          classPrefix={this.props.classPrefix}
          data-placeholder={this.props.placeholder}
          placeholder={this.props.placeholder}
          onSelectCategory={this.onSelect}
          name="category"
          fetchSuggestions={fetchSuggestions}
          onFocus={onFocus}
          onBlur={onBlur}
        />
        <input type="hidden" className={`${this.props.classPrefix}-key`} value={category.key} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./homepage/scripts/components/getquotes-category-autocomplete.js